export const appendCorrelationId = (url: string, correlationId: string): string => {
  const parsed = new URL(url);
  parsed.searchParams.set('correlationId', correlationId);
  return parsed.toString();
};
